
import { Component, Vue } from 'vue-property-decorator'
import { mapState } from 'vuex'
import keyCodeMapperCharacter from '@/utils/keycodemap.utils'
import * as onScan from 'onscan.js'
import ProductProvider from '@/resources/product.provider'
import StockLocationProvider from '@/resources/stock-location.provider'

@Component({
  components: {},
  computed: {
    ...mapState({
      selectBranch: (state: any) => state.Store.selectBranch
    })
  }
})
export default class ProductInLocation extends Vue {
  productService = new ProductProvider()

  stockLocationService = new StockLocationProvider()

  location: any = null

  selectBranch!: any

  loadingLocation = false

  loadingProduct = false

  page = 1

  totalPages = 0

  totalItems = 0

  items: any = []

  isFirstFetch = true

  mounted (): void {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const _this = this
    onScan.attachTo(document, {
      suffixKeyCodes: [13],
      reactToPaste: true,
      onScan (sCode) {
        const patternLocation = /^location::/
        if (patternLocation.test(sCode)) {
          _this.getLocation(sCode.split('::')[1])
        } else {
          _this.$buefy.toast.open({ message: 'กรุณาสแกน QR Code ของ Location', type: 'is-danger' })
        }
      },
      keyCodeMapper (oEvent: any) {
        if (keyCodeMapperCharacter[+oEvent.keyCode] !== undefined) {
          return keyCodeMapperCharacter[+oEvent.keyCode][+oEvent.shiftKey]
        }
        return onScan.decodeKeyEvent(oEvent)
      }
    })
  }

  onScroll (): void {
    if (this.loadingProduct) return
    if (this.page >= this.totalPages) return

    const el = this.$refs.scrollWrapper as HTMLElement
    if (!el) return

    const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 120

    if (nearBottom) {
      this.page++
      this.fetchPaginate()
    }
  }

  get groupedProducts (): Array<any> {
    const map: any = {}

    this.items.forEach((item: any) => {
      if (!item?.product?.id) {
        return
      }

      const productId = item.product.id

      if (!map[productId]) {
        map[productId] = {
          id: productId,
          name: item.product.name ?? '',
          code: item.code?.replace(/\.\d+$/, '') ?? '',
          image: item.product.photoUrls?.[0] ?? '',
          skus: []
        }
      }

      map[productId].skus.push({
        code: item.code ?? '',
        colorSize: `${item.sku?.color?.name?.toUpperCase() ?? ''} - ${item.sku?.size?.name?.toUpperCase() ?? ''}`,
        qty: item.qty ?? 0
      })
    })

    return Object.values(map)
  }

  get totalQty (): Array<any> {
    return this.items.reduce((sum: number, cur: any) => sum + cur.qty, 0)
  }

  async getLocation (locationId: string): Promise<void> {
    this.isFirstFetch = true
    try {
      this.loadingLocation = true
      const { data } = await this.stockLocationService.getLocationById(locationId, {
        warehouse: this.selectBranch.warehouse.id
      })
      if (data) {
        this.location = data
        this.fetchPaginate(true)
      } else {
        this.$buefy.toast.open({ message: 'Location นี้ไม่อยู่ใน Warehouse ที่คุณเลือก', type: 'is-danger' })
      }
    } catch (error) {
      this.$buefy.toast.open({ message: 'เกิดข้อผิดพลาดในการดึงข้อมูล location', type: 'is-danger' })
    } finally {
      this.loadingLocation = false
    }
  }

  // eslint-disable-next-line class-methods-use-this
  defaultEmptyObject (obj: any, key: string, defaultValue: string): string {
    return obj && obj[key] ? obj[key] : defaultValue
  }

  async fetchPaginate (isClear = false): Promise<any> {
      if (isClear) {
        this.page = 1
        this.totalPages = 0
        this.totalItems = 0
        this.items = []
      }

      try {
        this.loadingProduct = true
        const { data } = await this.stockLocationService.getMappingLocationPaginate({
          warehouse: this.selectBranch.warehouse.id,
          location: this.location.id,
          page: this.page,
          limit: 20
        })
        if (data.results?.length) {
          this.items = [
            ...this.items,
            ...data.results
          ]
        }
        this.totalPages = data.pages
        this.totalItems = data.total
      } catch (error: any) {
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: error?.message || error,
          type: 'error'
        })
      } finally {
        this.loadingProduct = false
        this.isFirstFetch = false
      }
    }

  // eslint-disable-next-line class-methods-use-this
  beforeDestroy (): void {
    onScan.detachFrom(document)
  }
}
